<div class="survey-container">
  <div #surveyContent id="surveyElement"></div>
</div>